export const authTypes = {
  LOGIN: 'auth_login',
  LOGOUT: 'auth_logout',
  LOADING: 'auth_loading',
};
